import util from '../util'

let controller = 'RestricoesContratacao'
export default Object.assign({}, util.GetCrud(controller, ['get', 'getall', 'post', 'put', 'persist']), { 
  CriacaoResponsavelLegal: function (numeroControleIF, codigoParceiro) {
    return util.Axios.Get(controller + `/Onboarding/${numeroControleIF}/CriacaoResponsavelLegal?codigoParceiro=${codigoParceiro}`)
  },
  Recusar: function (numeroControleIF) {
    return util.Axios.Patch(controller + `/Onboarding/ValidacaoBasica/Recusar?numeroControleIF=${numeroControleIF}`)
  },
  RealizarValidacaoInicial: function (documentoFederal, nome) {
    return util.Axios.Get(controller + `/${documentoFederal}/ValidacaoInicial?nome=${nome}`)
  }
})
